import { ANPREvent } from 'domain/anpr-event'

export const isSpeedViolation = (event: ANPREvent): boolean =>
  event.cameraSpeedLimit > 0 && event.speed > event.cameraSpeedLimit
